export const SECTION_DEFAULTS = {
  padding: '40px 20px 40px 20px', // top right bottom left
  paddingRoot: '40px 20px 40px 20px',
  paddingMobile: '40px 16px 40px 16px',
  paddingRootMobile: '40px 16px 40px 16px',
  innerWidthMax: '1280px',
  innerWidth: '100%',
};
